import { Button, UIHeading2, UIHeading3, UIHeading4 } from '@cian/ui-kit';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import type { IAiSummaryEmptyState, IAiSummaryNewbuilding } from '../../types';
import { FactRow } from './parts/factsRows';
import { NoDataBlock } from './parts/noDataBlock';
import { PeculiarityRow } from './parts/peculiarityRows';

import * as styles from './styles.css';

export interface IContentProps {
  summary: IAiSummaryNewbuilding;
  emptyState: IAiSummaryEmptyState;
}

export const Content = ({ summary, emptyState }: IContentProps): React.JSX.Element => {
  const hasHighlights = Boolean(summary.highlights?.items.length);
  const hasFeatures = Boolean(summary.features?.items.length);

  return (
    <div className={styles['container']}>
      <div className={styles['title-container']}>
        <div className={styles['title-wrapper']}>
          <UIHeading2>{summary.name}</UIHeading2>
          {summary.priceRange && <UIHeading4>{summary.priceRange}</UIHeading4>}
        </div>
        <Button afterIcon={<IconActionChevronRight12 color="icon-primary-default" />} theme="inverted">
          Перейти к ЖК
        </Button>
      </div>

      <div className={styles['facts-container']}>
        {!hasHighlights ? (
          <NoDataBlock {...emptyState} isFirstBlock={true} />
        ) : (
          <>
            <UIHeading3>{summary.highlights?.title}</UIHeading3>
            <div className={styles['facts-row-wrapper']}>
              {summary.highlights?.items.map(item => (
                <FactRow {...item} key={item.title} />
              ))}
            </div>

            {hasFeatures ? (
              <>
                <UIHeading3>{summary.features?.title}</UIHeading3>
                <div className={styles['facts-row-wrapper']}>
                  {summary.features?.items.map(item => (
                    <PeculiarityRow {...item} key={item.title} />
                  ))}
                </div>
              </>
            ) : (
              <NoDataBlock {...emptyState} isFirstBlock={false} />
            )}
          </>
        )}
      </div>
    </div>
  );
};
